var React = require('react');

function SetaBaixo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.95313 9C3.68657 9 3.45123 9.10605 3.24838 9.31814C3.07025 9.5044 2.98833 9.73689 3.00134 10.0156C3.01304 10.2943 3.10926 10.5268 3.28609 10.7131L14.8675 22.8214C15.1718 23.1396 15.5462 23.3 15.9909 23.3C16.4356 23.3 16.8218 23.1396 17.152 22.8214L28.7334 10.7131C28.9103 10.501 29 10.2617 29 9.99521C29 9.73009 28.9103 9.49081 28.7334 9.27871C28.5293 9.09245 28.2953 9 28.0287 9C27.7622 9 27.5398 9.09245 27.3617 9.27871L16.0091 21.1492L4.65787 9.27871C4.45502 9.09245 4.21968 9 3.95313 9Z"}));
}

SetaBaixo.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","className":"icon"};

module.exports = SetaBaixo;

SetaBaixo.default = SetaBaixo;
